import React, { useEffect, useRef } from 'react'
import { motion, useInView, useAnimation } from "framer-motion"

const SlideX = ({children, x_axis_start=100, x_axis_end=0}) => {
    const ref = useRef(null);
    const isInView = useInView(ref);

    const mainControls = useAnimation();

    useEffect(() => {
        if (isInView) {
            mainControls.start("visible");
        }else {
            mainControls.start("hidden");
        }
    }, [isInView, mainControls])

  return (
    <div ref={ref} style={{position: "relative"}}>
        <motion.div
        variants={{
            hidden: {opacity: 0, x: x_axis_start},
            visible: {opacity: 1, x: x_axis_end}
        }}
        initial="hidden"
        animate={mainControls}
        transition={{duration: .5, delay: .10}}
        >
            {children}
        </motion.div>
    </div>
  )
}

export default SlideX